// extracted by mini-css-extract-plugin
module.exports = {"battery-backup-Certified":"Certified_battery-backup-Certified__Mr_Jo"};